document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-upsell-modal]');
  const variantRoot = () => document.querySelector('variant-selects');

  if (!modal) return;

  let variants = [];
  let bypassUpsellModalCount = 0;
  let isModalOpen = false;

  const currency = 'USD';
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency
  });

  function money(cents) {
    return moneyFormatter.format((Number(cents || 0) / 100));
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getForm() {
    return (
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form')
    );
  }

  function getSubmitButton() {
    return document.querySelector('button[name="add"][type="submit"]');
  }

  function getSheathWrap() {
    return document.querySelector('[data-upsell-option="sheath"]');
  }

  function getEngravingWrap() {
    return document.querySelector('[data-upsell-option="engraving"]');
  }

  function getEngravingField() {
    return document.querySelector('[data-engraving-field]');
  }

  function getEngravingInput() {
    return document.querySelector('input[name="properties[Engraving text]"]');
  }

  function getVariantsJsonEl() {
    return document.querySelector('[data-product-variants]');
  }

  function refreshVariants() {
    const el = getVariantsJsonEl();
    try {
      variants = el ? JSON.parse(el.textContent) : [];
    } catch (e) {
      console.error('[upsell] Failed to parse variants JSON', e);
      variants = [];
    }
  }

  refreshVariants();

  function getFieldsets() {
    const root = variantRoot();
    return root ? [...root.querySelectorAll('fieldset')] : [];
  }

  function getFieldsetIndexByWrap(wrap) {
    if (!wrap) return -1;
    const fieldset = wrap.closest('fieldset');
    if (!fieldset) return -1;
    return getFieldsets().indexOf(fieldset);
  }

  function getCheckedValue(wrap) {
    if (!wrap) return null;
    const checked = wrap.querySelector('input[type="radio"]:checked');
    return checked ? checked.value.trim() : null;
  }

  function setRadioValue(wrap, value) {
    if (!wrap) return false;

    const radios = wrap.querySelectorAll('input[type="radio"]');

    for (const radio of radios) {
      if (normalize(radio.value) === normalize(value)) {
        const label = wrap.querySelector(`label[for="${radio.id}"]`);

        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));

        if (label) {
          label.click();
        } else {
          radio.click();
        }

        return true;
      }
    }

    return false;
  }

  function showEngravingField() {
    const field = getEngravingField();
    const input = getEngravingInput();

    if (field) field.style.display = '';
    if (input) input.disabled = false;
  }

  function hideEngravingField() {
    const field = getEngravingField();
    const input = getEngravingInput();

    if (field) field.style.display = 'none';
    if (input) {
      input.disabled = true;
      input.value = '';
    }
  }

  function getSelectedOptions() {
    return getFieldsets().map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value.trim() : null;
    });
  }

  function findVariantByOptions(options) {
    return variants.find((variant) => {
      return Array.isArray(variant.options) &&
        variant.options.length === options.length &&
        variant.options.every((value, index) => value === options[index]);
    }) || null;
  }

  function getAddonMeta(key) {
    const wrap = key === 'sheath' ? getSheathWrap() : getEngravingWrap();
    if (!wrap) return null;

    const radios = [...wrap.querySelectorAll('input[type="radio"]')];
    const hasYes = radios.some((r) => normalize(r.value) === 'yes');
    const hasNo = radios.some((r) => normalize(r.value) === 'no');

    if (!hasYes || !hasNo) return null;

    const optionIndex = getFieldsetIndexByWrap(wrap);
    if (optionIndex === -1) return null;

    const selectedOptions = getSelectedOptions();
    if (!selectedOptions.length) return null;

    const noOptions = [...selectedOptions];
    const yesOptions = [...selectedOptions];
    noOptions[optionIndex] = 'No';
    yesOptions[optionIndex] = 'Yes';

    const noVariant = findVariantByOptions(noOptions);
    const yesVariant = findVariantByOptions(yesOptions);

    if (!yesVariant || !noVariant) return null;

    const priceDiff = Number(yesVariant.price) - Number(noVariant.price);
    if (priceDiff <= 0) return null;

    return {
      wrap,
      priceDiff,
      selectedValue: getCheckedValue(wrap),
      optionIndex
    };
  }

  function getMissingUpsells() {
    refreshVariants();

    const items = [];

    const sheathMeta = getAddonMeta('sheath');
    if (sheathMeta && normalize(sheathMeta.selectedValue) === 'no') {
      items.push({
        key: 'sheath',
        title: 'Add Leather Sheath',
        badge: 'Best protection',
        desc: 'Protect your blade from scratches during storage and transport.',
        micro: 'A practical upgrade for long-term protection.',
        priceCents: sheathMeta.priceDiff
      });
    }

    const engravingMeta = getAddonMeta('engraving');
    if (engravingMeta && normalize(engravingMeta.selectedValue) === 'no') {
      items.push({
        key: 'engraving',
        title: 'Add Custom Engraving',
        badge: 'Personal touch',
        desc: 'Make it unique for yourself or turn it into a memorable gift.',
        micro: 'This option is best chosen before checkout.',
        priceCents: engravingMeta.priceDiff
      });
    }

    return items;
  }

  function renderUpsellItem(item) {
    const priceHtml = `
      <div class="mm-upsell-item__price">
        <div class="mm-upsell-item__price-value">+ ${money(item.priceCents)}</div>
        <div class="mm-upsell-item__price-note">one-time upgrade</div>
      </div>
    `;

    if (item.key === 'engraving') {
      return `
        <label class="mm-upsell-item">
          <div class="mm-upsell-item__main">
            <input type="checkbox" value="${item.key}" checked>

            <div class="mm-upsell-item__copy">
              <div class="mm-upsell-item__topline">
                <div class="mm-upsell-item__title">${item.title}</div>
                <div class="mm-upsell-item__badge">${item.badge}</div>
              </div>

              <div class="mm-upsell-item__desc">${item.desc}</div>
              <div class="mm-upsell-item__micro">${item.micro}</div>
            </div>

            ${priceHtml}
          </div>

          <div class="mm-upsell-item__extra" data-upsell-extra="engraving">
            <label class="mm-upsell-field-label" for="mmUpsellEngravingText">
              Add your personal touch
              <span class="mm-upsell-field-required">*</span>
            </label>
            <input
              id="mmUpsellEngravingText"
              type="text"
              class="mm-upsell-input"
              maxlength="120"
              placeholder="e.g. &ldquo;The Whitmore Family&rdquo; or &ldquo;Est. 2024&rdquo;"
              value="Handcrafted since 2019"
              required
            >
            <div class="mm-upsell-note">This is what we'll engrave, exactly as written. Edit the field above to personalize it, for example with a name, initials, or a special date.</div>
          </div>
        </label>
      `;
    }

    return `
      <label class="mm-upsell-item">
        <div class="mm-upsell-item__main">
          <input type="checkbox" value="${item.key}" checked>

          <div class="mm-upsell-item__copy">
            <div class="mm-upsell-item__topline">
              <div class="mm-upsell-item__title">${item.title}</div>
              <div class="mm-upsell-item__badge">${item.badge}</div>
            </div>

            <div class="mm-upsell-item__desc">${item.desc}</div>
            <div class="mm-upsell-item__micro">${item.micro}</div>
          </div>

          ${priceHtml}
        </div>
      </label>
    `;
  }

  function openModal(items) {
    const list = modal.querySelector('[data-upsell-modal-list]');
    if (!list) return;

    list.innerHTML = items.map(renderUpsellItem).join('');

    modal.hidden = false;
    isModalOpen = true;
    document.documentElement.classList.add('mm-upsell-modal-open');
    document.body.classList.add('mm-upsell-modal-open');

    const engravingCheckbox = modal.querySelector('input[type="checkbox"][value="engraving"]');
    const engravingExtra = modal.querySelector('[data-upsell-extra="engraving"]');

    if (engravingCheckbox && engravingExtra) {
      const sync = () => {
        engravingExtra.style.display = engravingCheckbox.checked ? 'block' : 'none';
      };
      engravingCheckbox.addEventListener('change', sync);
      sync();
    }
  }

  function closeModal() {
    modal.hidden = true;
    isModalOpen = false;
    document.documentElement.classList.remove('mm-upsell-modal-open');
    document.body.classList.remove('mm-upsell-modal-open');
  }

  function submitCurrentProduct() {
    const form = getForm();
    const button = getSubmitButton();

    if (button) {
      button.click();
      return;
    }

    if (form) {
      form.requestSubmit();
    }
  }

  function continueWithUpsells() {
    const checked = [
        ...modal.querySelectorAll('[data-upsell-modal-list] input[type="checkbox"]:checked')
    ].map((el) => el.value);

    const engravingTextFromModal =
        modal.querySelector('#mmUpsellEngravingText')?.value?.trim() || '';

    if (checked.includes('sheath')) {
        setRadioValue(getSheathWrap(), 'Yes');
    }

    if (checked.includes('engraving')) {
        setRadioValue(getEngravingWrap(), 'Yes');
    } else if (getEngravingWrap()) {
        setRadioValue(getEngravingWrap(), 'No');
        hideEngravingField();
    }

    closeModal();

    setTimeout(() => {
        const liveEngravingInput = getEngravingInput();

        if (checked.includes('engraving')) {
        showEngravingField();

        if (liveEngravingInput) {
            liveEngravingInput.disabled = false;
            liveEngravingInput.value = engravingTextFromModal;
            liveEngravingInput.dispatchEvent(new Event('input', { bubbles: true }));
            liveEngravingInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        }

        bypassUpsellModalCount = 2;
        submitCurrentProduct();
    }, 350);
    }

  function dismissModalOnly() {
    closeModal();
    }

    function continueWithoutUpsells() {
        closeModal();

        setTimeout(() => {
            bypassUpsellModalCount = 2;
            submitCurrentProduct();
        }, 80);
    }

  function maybeInterceptAddToCart(e) {
    const button = e.target.closest('button[name="add"][type="submit"]');
    const form = e.target.closest('form[action*="/cart/add"], product-form form');

    if (!button && !form) return;

    if (bypassUpsellModalCount > 0) {
        bypassUpsellModalCount -= 1;
        return;
    }

    if (isModalOpen) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      return;
    }

    const missingUpsells = getMissingUpsells();

    if (!missingUpsells.length) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    openModal(missingUpsells);
  }

  document.addEventListener('click', maybeInterceptAddToCart, true);
  document.addEventListener('submit', maybeInterceptAddToCart, true);

  modal.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-upsell-action]');
        if (!btn) return;

        const action = btn.getAttribute('data-upsell-action');

        if (action === 'continue') {
            continueWithUpsells();
        } else if (action === 'skip') {
            continueWithoutUpsells();
        } else if (action === 'close') {
            dismissModalOnly();
        }
    });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) {
      dismissModalOnly();
    }
  });
});